module.exports = __webpack_public_path__ + "img/V.5d42241d.jpg";